import $ from "jquery";
import VOID from "./framework/framework";
import {bound, filterInPlace, invoke} from "./framework/voidash";

class InputUnit extends VOID.EventEmitter {
  static selector() { return "input[type=text],input[type=number],input[type=range]"; };

  constructor($el) {
    super();
    this.$els = $el;
    this.$els.on("input change", bound(this, "handleChange"));
    this.paused = false;
    this.touched = false;
  }

  handleChange($evt) {
    this.touched = true;
    if (this.paused) return;
    this.emit(new VOID.Event("change", this, { eventType: $evt.type }));
  }

  getValue() {
    // input[type=range] defaults to a value in the middle (at least in FF)
    // so we have to discern whether the value was input by a user.
    return this.touched ? this.$els.val() : this.$els.attr("value");
  }

  setValue(value, eventType = "change") {
    this.paused = true;
    this.$els.val(value).trigger(eventType);
    this.paused = false;
  }
}

class RadioUnit extends VOID.EventEmitter {
  static selector() { return "input[type=radio]"; };

  constructor($el) {
    super();
    this.$els = $(`input[type=radio][name=${$el.attr("name")}]`);
    this.$els.on("change", bound(this, "handleChange"));
    this.paused = false;
  }

  handleChange($evt) {
    if (this.paused) return;
    this.emit(new VOID.Event("change", this, { eventType: $evt.type }));
  }

  getValue() { return this.$els.filter(":checked").val(); }

  setValue(value, eventType = "change") {
    this.paused = true;
    this.$els
      .each(function () {
        const $this = $(this);
        // noinspection EqualityComparisonWithCoercionJS
        $this.prop("checked", $this.val() == value);
      })
      .trigger(eventType);
    this.paused = false;
  }
}

const units = [InputUnit, RadioUnit];

const relevantElementsSelector = units.map(invoke("selector")).join(",");

export class InputMirror {
  constructor(opts) {
    this.opts = opts;
    this.$parents = $(opts.parents);
    this.initUnits();

    for (let i = 0; i < this.units.length; i++) {
      const unit = this.units[i];
      const value = unit.getValue();
      if (value) {
        this.handleChange(unit);
        break;
      }
    }
  }

  initUnits() {
    this.units = [];
    const inputs = this.$parents
      .find(relevantElementsSelector)
      .add(this.$parents.filter(relevantElementsSelector))
      .get();

    for (let i = 0; i < inputs.length; i++) {
      const input = inputs[i];
      const $input = $(input);
      for (let j = 0; j < units.length; j++) {
        const Unit = units[j];
        if ($input.is(Unit.selector())) {
          const unit = new Unit($input);
          this.units.push(unit);
          unit.on("change", ({eventType}) => { this.handleChange(unit, eventType); });
          filterInPlace(inputs, el => !$(el).is(unit.$els))
          i--; // current element was removed
          break;
        }
      }
    }
  }

  handleChange(unit, eventType = "change") {
    const value = unit.getValue();
    this.units.forEach(u => {
      if (u !== unit) u.setValue(value, eventType);
    });
  }
}

$(".js-input-mirror").each(function() {
  const $this = $(this);
  const inputMirror = new InputMirror({
    parents: $this
  });
  $this.data("inputMirror", inputMirror);
});
